import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useSandpack } from "../../hooks/useSandpack";
import { BackwardIcon, ForwardIcon, RefreshIcon } from "../../icons";
import { splitUrl } from "./utils";
export const Navigator = ({ clientId, onURLChange, }) => {
    var _a;
    const [baseUrl, setBaseUrl] = React.useState("");
    const { sandpack, dispatch, listen } = useSandpack();
    const [relativeUrl, setRelativeUrl] = React.useState((_a = sandpack.startRoute) !== null && _a !== void 0 ? _a : "/");
    const [backEnabled, setBackEnabled] = React.useState(false);
    const [forwardEnabled, setForwardEnabled] = React.useState(false);
    const c = useClasser("sp");
    React.useEffect(() => {
        const unsub = listen((message) => {
            if (message.type === "urlchange") {
                const { url, back, forward } = message;
                const [newBaseUrl, newRelativeUrl] = splitUrl(url);
                setBaseUrl(newBaseUrl);
                setRelativeUrl(newRelativeUrl);
                setBackEnabled(back);
                setForwardEnabled(forward);
            }
        }, clientId);
        return () => unsub();
    }, []);
    const handleInputChange = (e) => {
        const path = e.target.value.startsWith("/")
            ? e.target.value
            : `/${e.target.value}`;
        setRelativeUrl(path);
    };
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            //  Enter
            e.preventDefault();
            e.stopPropagation();
            if (typeof onURLChange === "function") {
                onURLChange(baseUrl + e.currentTarget.value);
            }
        }
    };
    const handleRefresh = () => {
        dispatch({ type: "refresh" });
    };
    const handleBack = () => {
        dispatch({ type: "urlback" });
    };
    const handleForward = () => {
        dispatch({ type: "urlforward" });
    };
    return (React.createElement("div", { className: c("navigator") },
        React.createElement("button", { "aria-label": "Go back one page", className: c("button", "icon"), disabled: !backEnabled, onClick: handleBack, type: "button" },
            React.createElement(BackwardIcon, null)),
        React.createElement("button", { "aria-label": "Go forward one page", className: c("button", "icon"), disabled: !forwardEnabled, onClick: handleForward, type: "button" },
            React.createElement(ForwardIcon, null)),
        React.createElement("button", { "aria-label": "Refresh page", className: c("button", "icon"), onClick: handleRefresh, type: "button" },
            React.createElement(RefreshIcon, null)),
        React.createElement("input", { "aria-label": "Current Sandpack URL", className: c("input"), name: "Current Sandpack URL", onChange: handleInputChange, onKeyDown: handleKeyDown, type: "text", value: relativeUrl })));
};
//# sourceMappingURL=index.js.map